export function pauseAudioEye({ length = 1000 } = {}) {
    window?.AudioEye?.MutationsApi?.setCooldownTime(length);
}
